import { atom } from 'jotai'
import { GetRequest, GetRequestCached2, GetRequestCachedV3, PostRequest, PostRequestCachedV3, PostRequestV2 } from '../api'
import { urls } from '../constants'
import { alertAtom, globalLoaderAtom } from './globalStateAtoms'
import { store } from './store'
import { decryptText } from '../loginDecode'
import { getDefaultStore } from 'jotai';
export const kenyaCountryCodesAtom = atom([])
export const fetchkenyaCountryCodesAtom = atom(null, async (get, set, data) => {
  try {
    const res = await GetRequestCached2(urls.GetCountryCode + '?', data)
    if (res.status) {
      set(
        kenyaCountryCodesAtom,
        res.Data.Table.map((a, i) => ({ ...a, id: i, name: a.CountryCode }))
      )
    }
  } catch (error) {
    console.error(error)
    set(kenyaCountryCodesAtom, [])
  }
})
export const paybillDetailsAtom = atom([])
export const fetchPaybillDetailsAtom = atom(null, async (get, set, data) => {
  try {
    const res = await GetRequestCached2(urls.getPayBillConfig + '?', data)
    if (res.status === 'Success') {
      set(paybillDetailsAtom, res.Data.Table[0])
    }
  } catch (error) {
    console.error(error)
    set(paybillDetailsAtom, [])
  }
})

export const lrListAtoms = atom([])
export const fetchlrListAtoms = atom(null, async (get, set, data) => {
  try {
    set(globalLoaderAtom, true)
    const res = await PostRequest(urls.getLRList, data)
    if (res.status === 'Success') {
      set(lrListAtoms, res.Data)
    } else {
      set(lrListAtoms, [])
      set(alertAtom, { show: true, msg: res?.ErrMessage || 'No data from server' })
    }
  } catch (error) {
    console.error(error)
    set(lrListAtoms, [])
  } finally {
    set(globalLoaderAtom, false)
  }
})
export const companySettingsAtom = atom({})
export const fetchCargoCompanySettingAtom = atom(null, async (get, set, data) => {
  try {
    set(globalLoaderAtom, true)
    const res = await PostRequestCachedV3(urls.getCargoSetting, data, false, 24 * 60 * 60)
    set(globalLoaderAtom, false)
    if (res.status === 'Success') {
      set(companySettingsAtom, res.Data[0])
    } else {
      set(companySettingsAtom, [])
    }
  } catch (err) {
    set(globalLoaderAtom, false)
    set(companySettingsAtom, [])
  }
})
export const CargoRoleRightsAtom = atom({})
export const fetchCargoRoleRightsAtomAtom = atom(null, async (get, set, data) => {
  try {
    set(globalLoaderAtom, true)
    const res = await GetRequestCachedV3(urls.getRoleRights, data)
    set(globalLoaderAtom, false)
    if ((res?.status === 'Success' || res?.Status === 'Success') && res?.Data) {
      set(CargoRoleRightsAtom, res.Data)
    } else {
      set(CargoRoleRightsAtom, {})
    }
  } catch (err) {
    set(globalLoaderAtom, false)
    set(CargoRoleRightsAtom, {})
  }
})
export const makeGetRequest = (url, data) => {
  return new Promise((resolve, reject) => {
    GetRequest(url, data)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => reject(err))
  })
}
export const lastLRAtom = atom({ LRNO: 0, FormattedLRNo: '' })
export const fetchLastLRAtom = atom(null, async (get, set, data) => {
  try {
    const res = await GetRequest(urls.getLastLR, data)
    if (res.status === 'Success') {
      set(lastLRAtom, res)
    } else {
      set(lastLRAtom, {})
    }
  } catch (error) {
    console.error(error)
    set(lastLRAtom, {})
  }
})
export const qrProcessignFees = atom(0)
export const fetchQrProcessignFeeAtom = atom(null, async (get, set, data) => {
  try {
    const res = await GetRequest(urls.getDQRDetails, data)
    if (res?.Data?.Table?.length > 0) {
      const fee = res?.Data?.Table?.[0].TransactionFeePer;
      set(qrProcessignFees, fee)
    } else {
      set(qrProcessignFees, 0)
      set(alertAtom, { show: true, msg: 'Dynamic QR Bank Account Details Not Found.\nPlease Confirm QR Beneficiary Update Status', nextId: '' })
    }
  } catch (error) {
    console.error(error)
    set(qrProcessignFees, 0)
  }
})
export const cityListAtom = atom([])
export const bookingCityListAtom = atom([])
export const isAssignedDispatchAtom = atom(false)
export const assignedVehileAtom = atom({})
export const branchListAtom = atom([])
export const ownCityBranchListAtom = atom([])

export const luggageSendOTP = async (data) => {
  store.set(globalLoaderAtom, true)
  try {
    const res = await PostRequestV2(urls.luggageSendOTPV2, data)
    if (res.Status) {
      res.OTP = decryptText(res.OTP)
    }
    store.set(globalLoaderAtom, false)
    return res
  } catch (error) {
    console.error(error)
    store.set(globalLoaderAtom, false)
    return error
  }
}

export const sendMtplMasterOdp = async (data) => {
  store.set(globalLoaderAtom, true)
  try {
    const res = await GetRequest(urls.getOneDayPassword, data)
    store.set(globalLoaderAtom, false)
    return res
  } catch (error) {
    console.error(error)
    store.set(globalLoaderAtom, false)
    return error
  }
}

export const validateMtplMasterOdp = async (data) => {
  store.set(globalLoaderAtom, true)
  try {
    const res = await GetRequest(urls.validateMtplMasterOdp, data)
    store.set(globalLoaderAtom, false)
    return res
  } catch (error) {
    console.error(error)
    store.set(globalLoaderAtom, false)
    return error
  }
}
export const branchRechargeOTP = async (data) => {
  store.set(globalLoaderAtom, true)
  try {
    const res = await GetRequest(urls.APIOTPBRanchRechargeV2 + '?', data)
    if (res.Status) {
      res.OTP = decryptText(res.OTP)
    }
    store.set(globalLoaderAtom, false)
    return res
  } catch (error) {
    console.error(error)
    store.set(globalLoaderAtom, false)
    return error
  }
}

export const cargoFOCSMSOtpDetails = async (data) => {
  store.set(globalLoaderAtom, true)
  try {
    const res = await PostRequestV2(urls.cargoFOCSMSOtpDetailsV2, data)
    if (res.Status) {
      res.OTP = decryptText(res.OTP)
    }
    store.set(globalLoaderAtom, false)
    return res
  } catch (error) {
    console.error(error)
    store.set(globalLoaderAtom, false)
    return error
  }
}
export const oTPForUserRoleRight = async (data) => {
  store.set(globalLoaderAtom, true)
  try {
    const res = await GetRequest(urls.oTPForUserRoleRightV2, data)
    if (res.Status) {
      res.OTP = decryptText(res.OTP)
    }
    store.set(globalLoaderAtom, false)
    return res
  } catch (error) {
    console.error(error)
    store.set(globalLoaderAtom, false)
    return error
  }
}
export const getDeliveryOTP = async (data) => {
  store.set(globalLoaderAtom, true)
  try {
    const res = await GetRequest(urls.getDeliveryOTPV2, data)
    if (res.Status) {
      res.OTP = decryptText(res.OTP)
    }
    store.set(globalLoaderAtom, false)
    return res
  } catch (error) {
    console.error(error)
    store.set(globalLoaderAtom, false)
    return error
  }
}
export const gstConfigAtom = atom({})
export const bookingDisableAtom = atom(false)
export const outStandingAmountAtom = atom(0)
export const cargoBalanceAtom = atom(0)
export const getBranchCreditLimit = (data) => {
  store.set(globalLoaderAtom, true);
  return GetRequest(urls.branchCreditLimit, data)
    .then((res) => {
      if (res.status !== 'Success') {
        throw new Error(res.ErrMessage || 'Request Failed');
      }
      if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
        throw new Error('Invalid response data');
      }
      return res.Data.Table[0];
    })
    .catch((err) => {
      alertAtom.set({
        show: true,
        msg: err?.message || 'Request Failed',
        nextId: '',
      });
      return null;
    })
    .finally(() => {
      store.set(globalLoaderAtom, false);
    });
};
let pollingIntervalId = null;
let stopPollingTimeoutId = null;

const POLLING_INTERVAL = 15 * 60 * 1000;

const getToday930AM = () => {
  const t = new Date();
  t.setHours(9, 30, 0, 0);
  return t;
};

const isBefore930AM = () => {
  return new Date() < getToday930AM();
};
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const startBranchCreditPolling = async (payload) => {
  if (pollingIntervalId || stopPollingTimeoutId) return;

  const pollOnce = async () => {
    const data = await getBranchCreditLimit(payload);
    if (data === null) return false;
    getDefaultStore().set(cargoBalanceAtom, data.CargoBalance);

    if (data.CargoBalance > 0) {
      getDefaultStore().set(outStandingAmountAtom, Math.ceil(data.CargoBalance));
      getDefaultStore().set(bookingDisableAtom, true);
      return true;
    }

    getDefaultStore().set(outStandingAmountAtom, 0);
    getDefaultStore().set(bookingDisableAtom, false);
    return false;
  };
  await delay(500);
  await pollOnce();
  if (!isBefore930AM()) return;

  pollingIntervalId = setInterval(async () => {
    await pollOnce();
  }, POLLING_INTERVAL);

  const stopAt = getToday930AM().getTime() - Date.now();

  stopPollingTimeoutId = setTimeout(() => {
    if (pollingIntervalId) {
      clearInterval(pollingIntervalId);
      pollingIntervalId = null;
    }
    stopPollingTimeoutId = null;
  }, stopAt);
};